export default __webpack_public_path__ + "static/media/conception-illustration.1308736c.png";